<template>
  <div class="row vh-100">
    <div
      v-if="cardTransferOutData !== null"
      class="col-5"
      style="border-right: 1px solid #e0e0e0"
    >
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Summary">
          <!-- {{ this.cardTransferOutData }} -->

          <a-descriptions
            title="Transfer Out Details"
            layout="horizontal"
            size="small"
            bordered
          >
            <a-descriptions-item label="Transfer ID" span="3">{{
              this.cardTransferOutData.id
            }}</a-descriptions-item>
            <a-descriptions-item label="Destination Site" span="3">{{
              this.cardTransferOutData.transferDestinationSiteName.name
            }}</a-descriptions-item>
            <a-descriptions-item label="Status" span="3">
              <a-tag
                v-if="
                  this.cardTransferOutData.transferStatus.name == 'Received'
                "
                color="#87d068"
                >{{
                  this.cardTransferOutData.transferStatus.name.toUpperCase()
                }}</a-tag
              >
              <a-tag v-else color="#ff9d5c">{{
                this.cardTransferOutData.transferStatus.name.toUpperCase()
              }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="Created By" span="3">{{
              this.cardTransferOutData.createdBy.name
            }}</a-descriptions-item>
          </a-descriptions>

          <a-descriptions
            title="Card Count Summary"
            layout="horizontal"
            size="small"
            bordered
          >
            <a-descriptions-item label="Total Quantity" span="6">{{
              this.cardTransferOutData.cards.length
            }}</a-descriptions-item>
            <a-descriptions-item label="Received" span="6">{{
              this.cardListGrouped['Received']
                ? this.cardListGrouped['Received'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit from Supplier" span="6">{{
              this.cardListGrouped['Ordered']
                ? this.cardListGrouped['Ordered'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit to Branch" span="6">{{
              this.cardListGrouped['In-Transit']
                ? this.cardListGrouped['In-Transit'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="Activated" span="6">{{
              this.cardListGrouped['Activated']
                ? this.cardListGrouped['Activated'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="Used" span="6">{{
              this.cardListGrouped['Assigned']
                ? this.cardListGrouped['Assigned'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="Deactivated" span="6">{{
              this.cardListGrouped['Deactivated']
                ? this.cardListGrouped['Deactivated'].length
                : 0
            }}</a-descriptions-item>
            <a-descriptions-item label="Rejected" span="6">{{
              this.cardListGrouped['Rejected']
                ? this.cardListGrouped['Rejected'].length
                : 0
            }}</a-descriptions-item>
          </a-descriptions>
        </a-tab-pane>
      </a-tabs>
    </div>

    <div class="col-12" v-if="cardTransferOutData === null">
      <h6 class="heading-small text-muted mb-4 text-truncate">
        <span>Create Transfer Out</span>
      </h6>

      <form id="form-proper" @submit.prevent="noop">
        <div class="py-2" style="border-bottom: 1px solid #e0e0e0;">
          <div>
            <div class="row mb-3">
              <div class="col">
                <a-radio-group v-model="transferBy" @change="onChange">
                  <a-radio
                    v-for="option in receivingOptions"
                    :style="radioStyle"
                    :key="option.key"
                    :value="option.key"
                  >
                    {{ option.value }}
                  </a-radio>
                </a-radio-group>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Destination Site">
                  <a-select
                    v-model="formData.destination_site_id"
                    :disabled="viewMode || cardTransferOutData !== null"
                    show-search
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="site in options.sites"
                      :key="site.id"
                      :value="site.id"
                    >
                      {{ site.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="transferBy == 'batch'">
              <div class="col">
                <base-input label="Enter Batch No." required>
                  <a-select
                    v-model="batchNo"
                    show-search
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="batch in options.batchNumbers"
                      :key="batch.batch_number"
                      :value="batch.batch_number"
                    >
                      {{ batch.batch_number }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="transferBy == 'card_no'">
              <div class="col">
                <base-input label="Enter Card No." required>
                  <a-input v-model="cardNumber" @keypress.enter="addData()" />
                </base-input>
              </div>
            </div>

            <div v-if="transferBy == 'range'">
              <div class="row">
                <div class="col">
                  <base-input label="Membership Program" required>
                    <a-select
                      v-model="formData.membership_program_id"
                      @change="onChangeMembershipProgram"
                    >
                      <a-select-option
                        v-for="membership_program in membershipPrograms"
                        :key="membership_program.id"
                        :value="membership_program.id"
                      >
                        {{ membership_program.name }}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <base-input label="Membership Level" required>
                    <a-select v-model="formData.membership_level_id">
                      <a-select-option
                        v-for="membershipLevel in membershipLevels"
                        :key="membershipLevel.id"
                        :value="membershipLevel.id"
                      >
                        {{ membershipLevel.name }}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <base-input label="Card Type" required>
                    <a-select v-model="formData.card_type_id">
                      <a-select-option
                        v-for="card_type in cardTypes"
                        :key="card_type.id"
                        :value="card_type.id"
                      >
                        {{ card_type.name }}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
              </div>
            </div>

            <div class="row" v-if="transferBy == 'range'">
              <div class="col">
                <base-input label="From" required>
                  <a-input v-model="cardNumberFrom" />
                </base-input>
              </div>
              <div class="col">
                <base-input label="To" required>
                  <a-input v-model="cardNumberTo" />
                </base-input>
              </div>
            </div>

            <div class="row" v-if="transferBy != 'batch'">
              <div class="col">
                <b-button
                  size="sm"
                  class="float-md-right success"
                  @click.prevent="addData"
                >
                  Add
                </b-button>
              </div>
            </div>
          </div>

          <br /><br />

          <div class="row">
            <div class="col">
              <a-table
                size="small"
                class="ant-table-striped"
                :rowClassName="
                  (record, index) =>
                    index % 2 === 1 ? 'table-striped-2' : null
                "
                v-if="transferBy == 'card_no'"
                :dataSource="cardsFull"
                :columns="cardDisplayColumns"
              />
              <a-table
                size="small"
                class="ant-table-striped"
                :rowClassName="
                  (record, index) =>
                    index % 2 === 1 ? 'table-striped-2' : null
                "
                v-if="transferBy == 'range'"
                :dataSource="cardRange"
                :columns="cardRangeColumns"
              />

              <!-- <a-table v-if="transferBy == 'card_no'" :dataSource="cards" :columns="cardDisplayColumns" />
              <a-table v-if="transferBy == 'range'" :dataSource="cardRange" :columns="cardRangeColumns" /> -->
            </div>
          </div>

          <!-- <div v-if="cardTransferOutData !== null">
            <div class="row">
              <div class="col">
                <base-input label="From">
                  <a-input v-model="cardNumberFrom" disabled />
                </base-input>
              </div>
              <div class="col">
                <base-input label="To">
                  <a-input v-model="cardNumberTo" disabled />
                </base-input>
              </div>
            </div>
          </div> -->
        </div>

        <br /><br /><br />

        <div
          style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px; z-index:99;"
        >
          <!-- <div> -->
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto mr-auto">
                <b-button
                  size="sm"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="closeDrawer"
                >
                  Cancel
                </b-button>
              </div>
              <div class="col-auto">
                <template>
                  <a-spin :spinning="formSubmitting">
                    <b-button
                      v-if="cardTransferOutData === null"
                      size="sm"
                      variant="primary"
                      @click.prevent="createTransferOut"
                      :disabled="cardTransferOutData !== null"
                    >
                      Create
                    </b-button>
                  </a-spin>
                </template>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="col-7" v-else>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Card List">
          <a-table
            class="ant-table-striped"
            size="small"
            :columns="cardDisplayColumnsFull"
            :data-source="cardTransferOutData.fullCardDetails"
            :rowClassName="
              (record, index) => (index % 2 === 1 ? 'table-striped-2' : null)
            "
          />
        </a-tab-pane>
      </a-tabs>
      <br />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';

export default {
  name: 'TransferOutForm',
  props: {
    cardTransferOutData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      // formClass: "col-12",
      currentSiteId: null,
      cardListGrouped: {},
      cardRange: [],
      cardsFull: [],
      membershipPrograms: [],
      cardTypes: [],
      membershipLevels: [],
      formSubmitting: false,
      transferBy: 'batch',
      // cardColumns: [ { title: "Card Number/s" } ],
      cardDisplayColumnsFull: [
        {
          title: 'Card Type',
          key: 'card_type_name',
          dataIndex: 'card_type_name'
        },
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
        {
          title: 'Status',
          key: 'card_status_name',
          dataIndex: 'card_status_name'
        }
      ],
      cardDisplayColumns: [
        {
          title: 'Card Type',
          key: 'card_type_name',
          dataIndex: 'card_type_name'
        },
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' }
      ],
      cardRangeColumns: [
        { title: 'From', key: 'from', dataIndex: 'from' },
        { title: 'To', key: 'to', dataIndex: 'to' },
        { title: 'Valid Card Count', key: 'count', dataIndex: 'count' }
      ],
      receivingOptions: [
        {
          key: 'batch',
          value: 'Batch'
        },
        {
          key: 'card_no',
          value: 'Card Number'
        },
        {
          key: 'range',
          value: 'Card Series Range (Serial)'
        }
      ],

      formData: {
        destination_site_id: null,
        membership_program_id: null,
        membership_level_id: null,
        card_type_id: null
      },
      options: {
        batchNumbers: [],
        sites: []
      },
      // cardNumbers: [],
      cards: [],
      batchNo: null,
      cardNumberFrom: null,
      cardNumberTo: null,
      cardNumber: null,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    };
  },

  methods: {
    onChangeMembershipProgram() {
      this.formData.card_type_id = null;
      this.getCardTypes(this.formData.membership_program_id);
      this.getMembershipLevels(this.formData.membership_program_id);
    },

    async getCardTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/card_types`
      );
      this.cardTypes = data;
    },

    async getMembershipLevels(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`
      );
      this.membershipLevels = data;
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data;
    },

    noop() {
      console.log('Prevent');
    },

    addData() {
      if (this.transferBy == 'card_no') {
        this.validateCards(this.cardNumber);
      } else if (this.transferBy == 'range') {
        this.validateRange(this.cardNumberFrom, this.cardNumberTo);
      }
    },

    async createTransferOut() {
      this.formSubmitting = true;
      let response = {};

      this.formData = {
        destination_site_id: this.formData.destination_site_id
      };

      if (this.formData.destination_site_id != null) {
        if (this.transferBy == 'batch') {
          response = await HTTPRequest.postRequest(
            '/api/v1/cards/transfer_out?origin_site_id=' + this.currentSiteId,
            {
              transfer_out: this.formData,
              batch_no: this.batchNo,
              type: this.transferBy,
              cards: [0]
            }
          );
        } else {
          this.formData = {
            destination_site_id: this.formData.destination_site_id
          };
          response = await HTTPRequest.postRequest(
            '/api/v1/cards/transfer_out?origin_site_id=' + this.currentSiteId,
            {
              transfer_out: this.formData,
              cards: this.cards,
              type: this.transferBy
            }
          );
        }

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Successful transaction'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description:
              'Something went wrong. Please try again. \n' + response.error, //response.errors,//'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Destination site is a required field',
          placement: 'topLeft'
        });
      }

      this.formSubmitting = false;
    },

    async getSites() {
      let curThis = this;
      this.options.sites = secureStorage.getItem('visitingSites');

      const filteredSites = this.options.sites.filter(
        item => item.id !== curThis.currentSiteId
      );
      this.options.sites = filteredSites;
    },
    async getBatches() {
      let curThis = this;
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_orders?&origin_site_id=' +
          curThis.currentSiteId +
          '&status=Posted Order&page=1&per_page=9999'
      );
      this.options.batchNumbers = response.data;
    },

    populateCardRange(from, to) {
      for (let i = from; i <= to; i++) {
        this.cards.push(i);
      }
    },

    onChange() {
      this.cards = [];
      this.cardNumberFrom = null;
      this.cardNumberTo = null;
      this.cardNumber = null;
      // this.formClass = "col-12";
      this.cardsFull = [];
    },

    clearForm() {
      this.transferBy = 'batch';
      this.cards = [];
      this.cardNumberFrom = null;
      this.cardNumberTo = null;
      this.cardNumber = null;
      // this.formClass = "col-7";
      this.cardsFull = [];
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },

    setFormData(data) {
      if (this.cardTransferOutData !== null) {
        const { destination_site_id, cards } = data;

        this.cardNumberFrom = cards[0].card_number;
        this.cardNumberTo = cards[cards.length - 1].card_number;

        this.formData = {
          destination_site_id
        };
      }
    },

    async validateCards(card_number) {
      this.activating = true;
      const response = await HTTPRequest.getRequest(
        '/api/v1/cards/validateCardForTransfer/' +
          card_number +
          '?origin_site_id=' +
          this.currentSiteId
      );

      if (response.id) {
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card is valid'
        });
        this.cards.push(this.cardNumber);
        this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x));
        this.cardsFull.push({
          card_number: response.card_number,
          serial_no: response.serial_no,
          card_type_name: response.cardType.name
        });
        this.cardsFull = _.uniqWith(this.cardsFull, _.isEqual);
        this.cardNumber = null;
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Card is invalid. Please check status of the card.'
        });
      }
      this.activating = false;
    },

    async validateRange(from, to) {
      this.activating = true;
      const response = await HTTPRequest.postRequest(
        '/api/v1/cards/validateCardRangeForTransfer?origin_site_id=' +
          this.currentSiteId,
        {
          from: from,
          to: to,
          card_type_id: this.formData.card_type_id,
          membership_program_id: this.formData.membership_program_id,
          membership_level_id: this.formData.membership_level_id
        }
      );

      if (response.length > 0) {
        // this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description:
            'Serial Range is valid. Valid card count: ' + response.length
        });

        for (var i = 0; i < response.length; i++) {
          this.cards.push(response[i].card_number);
          this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x));
        }
        this.cardNumberFrom = null;
        this.cardNumberTo = null;
        this.cardRange.push({
          key: this.cardRange.length + 1,
          from: from,
          to: to,
          count: response.length
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Serial Range is invalid.'
        });
      }
      this.activating = false;
    }
  },

  mounted: async function() {
    this.setFormData(this.cardTransferOutData);
    // Process Full Card List
    if (this.cardTransferOutData != null) {
      this.cardListGrouped = _.groupBy(
        this.cardTransferOutData.fullCardDetails,
        card => card.card_status_name
      );
      this.formClass = 'col-7';
    }

    this.getMembershipPrograms();
    this.currentSiteId = secureStorage.getItem('currentSiteId');
    this.getSites();
    this.getBatches();
  },

  watch: {
    cardTransferOutData: function(data) {
      if (data !== null) {
        this.setFormData(data);
      } else {
        this.clearForm();
      }
    }
  }
};
</script>

<style scoped></style>
